import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OwnerLogo } from './OwnerLogo.js';
import { TenantLogo } from './TenantLogo.js';
/**
 * Letterhead for the "clean" frame templates (ADR-0061): owner + tenant
 * logos always render; a configurable document title row renders below them
 * when present; there is NO form number ("RR-xx"). Use inside
 * `<TemplateDocument>`'s header slot so the band repeats per printed page.
 *
 * `title` null/empty ⇒ logos only (the "Lägg till sidhuvud" checkbox off).
 */
export function CleanLetterhead(props) {
    const title = (props.title ?? '').trim();
    return (_jsxs("div", { className: "flex items-start justify-between gap-4", style: { width: '100%' }, children: [_jsxs("div", { className: "flex flex-col items-start text-left", children: [_jsx("div", { className: "flex-shrink-0", children: _jsx(OwnerLogo, {}) }), title !== '' && (_jsx("span", { className: "mt-3 text-[12px] font-semibold leading-tight", children: title }))] }), _jsx("div", { className: "flex-shrink-0", children: _jsx(TenantLogo, {}) })] }));
}
/**
 * Page footer for the clean frame templates — Regta wordmark only, no form
 * number. Mirrors `TemplateFooter` minus the `formNumber` span.
 */
export function CleanFooter() {
    return (_jsx("div", { className: "flex justify-end font-sans text-[9px] text-stone-500", children: _jsx("span", { children: "Regta" }) }));
}
//# sourceMappingURL=CleanLetterhead.js.map